import React, { useRef, useState } from "react";
import { Input } from "@heroui/react";
import { Icon } from "@iconify/react";

const CurrencyInput = ({
    label,
    value,
    onChange,
    icon = "lucide:dollar-sign",
    currency = "USD",
    isReadOnly = false,
    className = "",
    ...props
}) => {
    // Estado local para el valor en edición
    const [editingValue, setEditingValue] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const inputRef = useRef(null);

    // Formatear como moneda
    const formatCurrency = (val) => {
        if (val === undefined || val === null || val === "") return "";
        const numericValue = typeof val === "string" ? parseFloat(val.replace(/,/g, ".").replace(/[^\d.\-]/g, "")) : val;
        if (isNaN(numericValue)) return "";
        const locale = currency === "EUR" ? "es-ES" : "es-CL";
        const currencySymbol = currency === "EUR" ? "EUR" : "USD";
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currencySymbol,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericValue);
    };

    // Al enfocar, mostrar el valor sin formato
    const handleFocus = (e) => {
        setIsEditing(true);
        setEditingValue(value !== undefined && value !== null ? value.toString() : "");
        // Seleccionar todo el texto para facilitar la edición
        setTimeout(() => {
            if (inputRef.current) inputRef.current.select();
        }, 0);
    };

    // Al cambiar, solo permitir números y un separador decimal
    const handleChange = (e) => {
        let val = e.target.value;
        // Permitir borrar
        if (val === "") {
            setEditingValue("");
            onChange("");
            return;
        }
        // Permitir solo números y un separador decimal
        if (/^\d*(\.|,)?\d{0,2}$/.test(val)) {
            // Reemplazar coma por punto para el valor numérico
            setEditingValue(val.replace(",", "."));
        }
    };

    // Al perder el foco, formatear el valor
    const handleBlur = (e) => {
        setIsEditing(false);
        let val = editingValue;
        if (val === "") {
            onChange("");
            return;
        }
        // Reemplazar coma por punto
        val = val.replace(",", ".");
        // Limitar a dos decimales
        const num = parseFloat(val);
        if (!isNaN(num)) {
            onChange(num.toFixed(2));
        } else {
            onChange("");
        }
    };

    return (
        <Input
            label={label}
            value={isEditing ? editingValue : formatCurrency(value)}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            startContent={
                <Icon
                    icon={icon}
                    className="text-default-400 pointer-events-none flex-shrink-0"
                />
            }
            classNames={{
                label: "text-sm font-medium",
                input: "text-sm",
            }}
            isReadOnly={isReadOnly}
            className={className}
            inputRef={inputRef}
            {...props}
        />
    );
};

export default CurrencyInput; 